/**
 * Reports — unified reporting dashboard.
 */
import { motion } from "framer-motion";
import { BarChart3, FileBarChart, Users, DollarSign, Sparkles, Download } from "lucide-react";
import PremiumNav from "@/components/premium/PremiumNav";
import PremiumFooter from "@/components/premium/PremiumFooter";
import { PremiumCard, PremiumButton, SectionHeading, EmptyState } from "@/components/premium/Primitives";

const REPORT_TILES = [
  { label: "Channel Reports",   value: "—", Icon: BarChart3 },
  { label: "Teaching Reports",  value: "—", Icon: FileBarChart },
  { label: "Marketing Reports", value: "—", Icon: Users },
  { label: "Revenue",           value: "—", Icon: DollarSign },
];

export default function PremiumReports() {
  return (
    <div className="min-h-screen bg-slate-50/40 font-sans" data-testid="premium-reports">
      <PremiumNav/>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10">
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="flex items-end justify-between flex-wrap gap-4 mb-8">
          <SectionHeading eyebrow="Reports" title="Performance across every channel" subtitle="Unified reporting for channels, students, clients and revenue." />
          <PremiumButton icon={Download} variant="secondary">Export all</PremiumButton>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          {REPORT_TILES.map((t) => (
            <PremiumCard key={t.label} className="p-5" hover={false}>
              <div className="flex items-center justify-between">
                <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">{t.label}</div>
                <div className="w-8 h-8 rounded-lg bg-brand-50 text-[#A855F7] flex items-center justify-center">
                  <t.Icon className="w-4 h-4"/>
                </div>
              </div>
              <div className="mt-3 font-heading text-3xl font-bold text-[#111111]">{t.value}</div>
            </PremiumCard>
          ))}
        </div>

        <PremiumCard className="p-2" hover={false}>
          <EmptyState
            icon={Sparkles}
            title="No reports yet"
            subtitle="Generate your first Channel Assessment or run a project to see reports here."
            action={<PremiumButton>Generate first report</PremiumButton>}
          />
        </PremiumCard>
      </div>
      <PremiumFooter />
    </div>
  );
}
